import classNames from 'classnames';
import React from 'react';
import * as styles from './PricingModalLine.module.scss';

interface LineProps {
  active?: boolean;
}

const PricingModalLine = ({ active }: LineProps) => {
  return (
    <div className={classNames(styles.line, { [styles.lineActive]: active })} />
  );
};

export default PricingModalLine;
